// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import xcmeetEntity from './entities/xcmeet.json';
import xcmeetMenu from '../pages/xcmeet/menu.json';
import xcmeetFullForm from '../pages/xcmeet/forms/full.json';
import xcmeetContextForm from '../pages/xcmeet/forms/context.json';
import xcmeetMiniForm from '../pages/xcmeet/forms/mini.json';
import xcmeetLookupForm from '../pages/xcmeet/forms/lookup.json';
import xcmeetTableView from '../pages/xcmeet/views/table.json';
import xcmeetStagesView from '../pages/xcmeet/views/stages.json';
import xcmeetCardsView from '../pages/xcmeet/views/cards.json';
import xcmeetInlineView from '../pages/xcmeet/views/inline.json';
import xcmeetBacklogView from '../pages/xcmeet/views/backlog.json';
import xcmeetSplitView from '../pages/xcmeet/views/split.json';
import xcmeetCalendarView from '../pages/xcmeet/views/calendar.json';
import xcmeetDashboardView from '../pages/xcmeet/views/dashboard.json';

/** Тип запису «Засідання ради» зі сторінками пакета: меню, форми та подання з pages/xcmeet/. */
export const xcmeetDefinition: IRecordTypeDefinition = {
  ...xcmeetEntity,
  views: assembleViewSet({
      table: xcmeetTableView,
      stages: xcmeetStagesView,
      cards: xcmeetCardsView,
      inline: xcmeetInlineView,
      backlog: xcmeetBacklogView,
      split: xcmeetSplitView,
      calendar: xcmeetCalendarView,
      dashboard: xcmeetDashboardView,
  }),
  form: xcmeetFullForm,
  forms: { full: xcmeetFullForm, context: xcmeetContextForm, mini: xcmeetMiniForm, lookup: xcmeetLookupForm },
  menu: xcmeetMenu,
} as IRecordTypeDefinition;
